import {
  currentOrPastDateRangeUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import fullSchema from '../../schema';

// Override the date hint to note estimates are acceptable
const DATE_HINT =
  'Select a month. Enter 1 or 2 digits for the day and 4 digits for the year. You can give an estimate for these dates, if needed.';
const DAY_ERROR = 'Enter a day between 1 and 31';
const dateOptions = {
  monthSelect: true,
  removeDateHint: true,
  hint: DATE_HINT,
  customDayErrorMessage: DAY_ERROR,
};

// Section V Item 13 — POW confinement dates. Follow-up to the POW eras page;
// only reached when the Veteran answered "yes" on the POW page (page-level
// `depends` in the form config).
export default {
  uiSchema: {
    ...titleUI('Period of time held as a POW'),
    powConfinement: currentOrPastDateRangeUI(
      { ...dateOptions, title: 'Start date' },
      { ...dateOptions, title: 'End date' },
      'End date should be after start date',
    ),
  },
  schema: {
    type: 'object',
    required: ['powConfinement'],
    properties: {
      powConfinement: fullSchema.properties.powConfinement,
    },
  },
};
